import {apiUrl, get, post} from '../http'
import {handleSend} from '../handleSend'
// import store from '../store' import {handleSend} from "./handleSend";
// export const requestApi = data => post('/handle', data)

// const apiDict = [
//   {name: 'login', appCode: '00', bizCode: '0001', operaType: 0}, // 登录
//   {name: 'logout', appCode: '00', bizCode: '0002', operaType: 0}, // 登出
//   {name: 'getTreeList', appCode: '00', bizCode: '0001', operaType: 0}, // 获取树形列表
//   {name: 'getTableList', appCode: '00', bizCode: '0002', operaType: 0}, // 获取下拉列表
//   {name: 'getFunctionList', appCode: '00', bizCode: '0001', operaType: 0}, // 获取业务功能列表
//   {name: 'getSysParameter', appCode: '00', bizCode: '0002', operaType: 0}, // 系统参数查询
//   {name: 'updateSysParmeter', appCode: '00', bizCode: '0001', operaType: 0}, // 系统参数修改
//   {name: 'getTableList', appCode: '00', bizCode: '0002', operaType: 0}, // 获取下拉列表
// ]

// export const api = (name, data) => {
//   for (let row of apiDict) {
//     if (row.name === name) {
//       let encryptionData = makeMsgBody(row.appCode, row.bizCode, data, row.operaType)
//       return post('/handle', encryptionData)
//     }
//   }
//   alert('接口不存在')
// }

export const AccessControlApi = {
  baseUrl () { return apiUrl },
  //   *公共接口*

  // 下载文件
  downLoadFile (data) {
    return get('/downFile', data)
  },

  // 获取加密因子
  getWorkKeys (data) {
    return post('/getWorkKeys', data, 'Alert')
  },
  // 登录
  login (data) {
    return handleSend(data, '00', '0001', '0')
  },
  // 登出
  logout (data) {
    return handleSend(data, '00', '0002', '0')
  },
  // 获取树形列表
  getTreeList (TreeCode, operatype, TreeNode) {
    let data = {treeCode: TreeCode, treeNode: TreeNode}
    return handleSend(data, '00', '0003', String(operatype), 'message')
  },
  // 获取下拉列表
  getTableList (CodeTableOrListNo, CoditionList) {
    let data = {codeTableOrListNo: CodeTableOrListNo, codeType: '1', coditionList: CoditionList}
    return handleSend(data, '00', '0004', '0', false)
  },
  // 获取业务功能列表
  getFunctionList (NodeId) {
    let data = {nodeId: NodeId}
    return handleSend(data, '00', '0005', '0')
  },
  // 修改密码
  handleUpdatePwd (data) {
    return handleSend(data, '00', '0006', '0')
  },
  //     *系统管理*
  // 系统参数查询
  querySysParameter (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '10', '0001', '0', 'message')
  },
  // 系统参数修改
  updateSysParmeter (data) {
    return handleSend(data, '10', '0002', '0')
  },
  //   *机构管理*
  // 新增/修改机构接口
  handleInstitution (data, type = 0) {
    if (type === 0) {
      return handleSend(data, '20', '0001', '0')
    }
    return handleSend(data, '20', '0001', '1')
  },
  // 查询机构接口
  queryInstitutionList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '20', '0002', '0', 'message')
  },
  // 机构撤销接口
  delInstitution (data) {
    return handleSend(data, '20', '0003', '0')
  },
  //
  //   *用户管理*
  //
  // 新增/修改用户接口
  handleUser (data, type = 0) {
    if (type === 0) {
      return handleSend(data, '61', '0001', '0')
    }
    return handleSend(data, '61', '0001', '1')
  },
  // 查询用户接口
  queryUserList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '61', '0002', '0', 'message')
  },
  // 注销/停用/释放登录状态接口
  stopUser (data, type) {
    // console.log('状态操作接口', type, String(type))
    return handleSend(data, '61', '0004', String(type))
  },
  // 重置密码及启用
  resetPwd (data) {
    return handleSend(data, '61', '0005', '0')
  },
  // 查询用户角色接口
  queryUserRole (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '61', '0006', '0', 'message')
  },
  // 用户角色分配接口
  setUserRole (data) {
    return handleSend(data, '61', '0007', '0')
  },
  // 管理范围设置
  setManageArea (data) {
    return handleSend(data, '61', '0008', '0')
  },
  // 管理范围查询
  queryManageArea (data) {
    return handleSend(data, '61', '0009', '0', 'message')
  },
  //
  //    *角色管理*
  //
  // 新增/修改角色资料
  handleRoleInfo (data, type) {
    return handleSend(data, '62', '0001', String(type))
  },
  // 查询角色资料
  queryRoleInfo (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '62', '0002', '0', 'message')
  },
  // 删除角色资料
  delRoleInfo (data) {
    return handleSend(data, '62', '0003', '0')
  },
  // 查询角色权限接口
  queryRoleRight (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '62', '0004', '0', 'message')
  },
  // 设置角色资料
  setRoleRight (data) {
    return handleSend(data, '62', '0005', '0')
  },
  // 审计日志查询
  queryLog (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '62', '0006', '0', 'message')
  },
  //
  //  *设备区域管理*
  //
  // 新增/修改设备区域
  handleDeviceArea (data, type) {
    return handleSend(data, '63', '0001', String(type))
  },
  // 查询设备区域
  queryDeviceArea (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '63', '0002', '0')
  },
  // 删除设备区域
  delDeviceArea (data) {
    return handleSend(data, '63', '0003', '0')
  },
  //
  //  *设备管理*
  //
  // 新增/修改控制器
  handleDeviceControl (data, type) {
    return handleSend(data, '64', '0001', String(type))
  },
  // 查询设备
  queryDevice (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '64', '0002', '0', false)
  },
  // 删除设备
  delDevice (data) {
    return handleSend(data, '64', '0003', '0')
  },
  // 新增/修改门资料
  handleDoorInfo (data, type) {
    return handleSend(data, '64', '0004', String(type))
  },
  // 查询门资料
  queryDoorInfo (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '64', '0005', '0', false)
  },
  // 删除门资料
  delDoorInfo (data) {
    return handleSend(data, '64', '0006', '0')
  },
  // 设置/修改门开放时间
  handleDoorOpenTime (data, type) {
    return handleSend(data, '64', '0007', String(type))
  },
  // 查询门开放时间
  queryDoorOpenTime (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '64', '0008', '0', 'message')
  },
  // 删除门开放时间
  delDoorOpenTime (data) {
    return handleSend(data, '64', '0009', '0')
  },
  // 远程开关门
  remoteDoorControl (data, type) {
    return handleSend(data, '64', '0010', String(type))
  },
  // 控制器操作
  handleDevice (data, type) {
    return handleSend(data, '64', '0011', String(type))
  },
  handleAlarm (data) {
    return handleSend(data, '64', '0012', '0')
  },
  setDeviceParam (data) {
    return handleSend(data, '64', '0013', '0')
  },
  // 增/修改节假日
  handleHoliday (data, type) {
    return handleSend(data, '64', '0021', String(type))
  },
  // 查询节假日
  queryHoliday (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '64', '0022', '0', 'message')
  },
  // 删除节假日
  delHoliday (data) {
    return handleSend(data, '64', '0023', '0')
  },
  //
  //  *部门管理*
  //
  // 新增/修改部门
  handleDepartment (data, type) {
    return handleSend(data, '65', '0001', String(type))
  },
  // 查询部门
  queryDepartment (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '65', '0002', '0', 'message')
  },
  delDepartment (data) {
    return handleSend(data, '65', '0003', '0')
  },
  //
  //  *人员管理*
  //
  // 新增/修改人员
  handlePerson (data, type) {
    return handleSend(data, '66', '0001', String(type))
  },
  // 查询人员
  queryPerson (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '66', '0002', '0', 'message')
  },
  //
  // 批量导入人员
  batchCreatePerson (data) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', '0')
    fd.append('AppCode', '66')
    fd.append('BizCode', '0003')
    // fd = JSON.stringify(fd)
    return post('/uploadFiles', fd, 'Alert', config)
  },
  //
  // 冻结/注销人员接口
  handleFreezePerson (data, type) {
    return handleSend(data, '66', '0004', String(type))
  },
  // 人脸采集
  collectPersonCertifyInfo (data) {
    return handleSend(data, '66', '0005', '0')
  },
  getPicture (msgData) {
    let data = {
      msg: {
        AppCode: '66',
        BizCode: '0006',
        // operaType: handleType,
        BizBodyMsg: msgData
      },
      sign: ''
    }
    return post('/getPicture', data, false)
  },
  upLoadFacePic (data) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', '0')
    fd.append('AppCode', '66')
    fd.append('BizCode', '0007')
    // fd = JSON.stringify(fd)
    return post('/uploadFiles', fd, 'Alert', config)
  },
  getPersonCertifyInfo (data) {
    return handleSend(data, '66', '0008', '0')
  },
  //
  //  *通行设置*
  //
  //  新增/修改通行规则
  handleCommPassRule (data, type) {
    return handleSend(data, '67', '0001', String(type))
  },
  // 查询通行规则接口
  queryCommPassRule (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '67', '0002', '0', 'message')
  },
  // 删除通行规则接口
  delPassRule (data) {
    return handleSend(data, '67', '0003', '0')
  },
  // 查询通行范围
  queryCommRuleArea (data) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '67', '0004', '0', 'message')
  },
  // 设置通行范围
  setCommPassRule (data) {
    return handleSend(data, '67', '0005', '0')
  },
  //  通用通行设置/修改
  handleCommPassSetting (data, type) {
    return handleSend(data, '67', '0006', String(type))
  },
  // 通用通行设置查询
  queryCommPassSetting (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '67', '0007', '0', 'message')
  },
  // 删除通行设置
  delCommPassSetting (data) {
    return handleSend(data, '67', '0008', '0')
  },
  // 临时通行设置/修改
  handleTempPassSetting (data, type) {
    return handleSend(data, '67', '0009', String(type))
  },
  // 临时通行设置查询
  queryTempPassSetting (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '67', '0010', '0', 'message')
  },
  // 删除临时通行设置
  delTempPassSetting (data) {
    return handleSend(data, '67', '0011', '0')
  },
  // 权限下载
  downLoadSetting (data, type) {
    return handleSend(data, '67', '0012', String(type))
  },
  // 下载指定人员卡数据到指定控制器
  downPersonCard (data) {
    return handleSend(data, '67', '0013', '0')
  },
  // 删除人员卡数据
  delPersonCard (data) {
    return handleSend(data, '67', '0014', '0')
  },
  queryCommPassRule2 (data) {
    return handleSend(data, '67', '0015', '0', 'message')
  },
  //
  //  *通行查询*
  //
  // 通行查询
  queryPass (data, type = '0') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    // console.log('通行查询', typeof data.pageSize)
    return handleSend(data, '68', '0001', type, false)
  },
  // 通行历史记录查询
  queryPassHistory (data, type = '0') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '68', '0002', type, 'message')
  },
  // 数据下载失败记录查询
  queryDataDownloadFail (data, type = '0') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '68', '0003', type, 'message')
  },
  //
  //  *门禁通行状况监控*
  //
  // 门禁通行状况查询
  DoorAccessStatus (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    // console.log('门禁通行状况查询', typeof data.pageSize)
    return handleSend(data, '69', '0001', '0', false)
  }
}



// WEBPACK FOOTER //
// ./src/request/AccessControl/api.js